import { useState, useEffect } from "react";
import { Button, Modal, Table } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CalculateFormula from "./CalculateFormula";
import "./CalculateTotalModal.scss";

function CalculateTotalModal({ type = "", info, record, getColumn, api }) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    let res = await axios.get(`${api}/${record.ID}`);

    if (type === "process") {
      setData(
        res.data?.GasSummaries.map((d) => ({
          ...d,
          HeatValue: res.data.HeatValue,
          Total: res.data.KgCO2e,
          Scalar: res.data.Scalar,
        }))
      );
    } else {
      setData([res.data]);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      getData();
    }
  }, [isModalOpen]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button type="primary" onClick={showModal} disabled={false}>
        {t("Calculate.Total.Button")}
      </Button>
      <Modal
        title={t("Calculate.Total.Title")}
        open={isModalOpen}
        onCancel={handleCancel}
        width={1200}
        footer={
          <Button onClick={handleCancel} disabled={false}>
            {t("Buttons.Cancel")}
          </Button>
        }
        className="customer"
      >
        {info.map((item) => (
          <CalculateFormula>{t(item)}</CalculateFormula>
        ))}

        <Table
          scroll={{
            x: "max-content",
          }}
          columns={getColumn(data)}
          dataSource={data}
          loading={loading}
        />
      </Modal>
    </>
  );
}

export default CalculateTotalModal;
